// Phase 8 R2 — flip canned job active/inactive.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

interface Vars {
  cannedJobId: string;
  active: boolean;
}

export function useSetCannedJobActive() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ cannedJobId, active }: Vars): Promise<void> => {
      const { error } = await (supabase as any).rpc('set_canned_job_active', {
        p_canned_job_id: cannedJobId,
        p_active: active,
      });
      if (error) throw error;
    },
    onSuccess: (_d, { active }) => {
      qc.invalidateQueries({ queryKey: ['canned-jobs-admin'] });
      qc.invalidateQueries({ queryKey: ['canned-jobs'] });
      toast({
        title: active ? 'Canned job activated' : 'Canned job deactivated',
      });
    },
    onError: (err: any) => {
      toast({
        title: 'Could not change activation state',
        description: err?.message ?? 'Unknown error',
        variant: 'destructive',
      });
    },
  });
}
